var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconLED_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 282",
    fill: "#a1a1a1",
    stroke: "#707070",
    d: "M0 0h80v80H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconLED_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 382",
    fill: "none",
    d: "M0 0h80v80H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "IconLED",
    clipPath: "url(#IconLED_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 380",
    fill: "#231815",
    clipPath: "url(#IconLED_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 534",
    d: "M67.749 45.492c-11.838 0-21.468-11.831-21.468-26.374a.5.5 0 10-1 0c0 14.326-9.482 26.155-21.136 26.369a.51.51 0 00-.491.511.5.5 0 00.491.5c11.641.214 21.123 12.029 21.136 26.337a.5.5 0 001 0c.013-14.525 9.643-26.342 21.468-26.342a.5.5 0 000-1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 535",
    d: "M26.594 17.49c3.881.075 7.041 4.25 7.045 9.307a.5.5 0 001 0c0-5.133 3.214-9.309 7.155-9.309a.5.5 0 000-1c-3.945 0-7.155-4.181-7.155-9.321a.5.5 0 00-1 0c0 5.063-3.161 9.244-7.045 9.319a.5.5 0 000 1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 536",
    d: "M12.242 12.844a3.777 3.777 0 013.073 4.138.5.5 0 001 0c0-2.282 1.4-4.139 3.12-4.139a.5.5 0 100-1c-1.72 0-3.12-1.859-3.12-4.144a.5.5 0 00-1 0 3.779 3.779 0 01-3.073 4.144.5.5 0 100 1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 537",
    d: "M27.942 31.88a.5.5 0 00-.5-.5c-3.945 0-7.155-4.181-7.155-9.321a.5.5 0 10-1 0c0 5.064-3.16 9.244-7.045 9.319a.5.5 0 000 1c3.88.075 7.041 4.25 7.045 9.307a.5.5 0 001 0c0-5.133 3.214-9.309 7.155-9.309a.5.5 0 00.5-.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLed);
export default __webpack_public_path__ + "static/media/IconLED.0e4e041e469c2de7.svg";
export { ForwardRef as ReactComponent };